import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../services/server/axios";
import { Button, message } from "antd";
import { useTranslation } from "react-i18next";

const AccountInformation = () => {
  const { t } = useTranslation();

  const [form, setForm] = useState({
    email: "",
    registration: "",
    username: "",
    whatssap: "",
    code_postal: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    const token = localStorage.getItem("authToken");

    axiosInstance
      .get("/getUserData", {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        const u = res.data;
        setForm({
          email: u.email,
          registration: u.created_at?.split("T")[0] || "",
          username: u.username || "",
          whatssap: u.whatssap || "",
          code_postal: u.code_postal || "",
        });
      });
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.id]: e.target.value });
  };

  const handleSave = () => {
    const token = localStorage.getItem("authToken");

    axiosInstance
      .put(
        "/updateUserData",
        {
          username: form.username,
          whatssap: form.whatssap,
          code_postal: form.code_postal,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then(() => {
        message.success(t("profile_updated"));
        setErrors({});
      })
      .catch((err) => {
        if (err.response?.status === 422) {
          setErrors(err.response.data.errors);
        } else {
          message.error(t("profile_update_failed"));
        }
      });
  };

  return (
    <div className="p-1">
      <div style={{ maxWidth: "672px" }}>
        <h1
          className="h2 fw-bold mb-5"
          style={{ color: "var(--primary-color3)" }}
        >
          {t("account_information")}
        </h1>

        {/* Personal Information */}
        <div
          className="card rounded-3 p-4 mb-5"
          style={{ background: "var(--primary-color8)" }}
        >
          <h2
            className="h4 fw-semibold mb-4"
            style={{ color: "var(--primary-color3)" }}
          >
            {t("personal_information")}
          </h2>

          <div className="row g-4">
            <div className="col-12">
              <label
                htmlFor="email"
                className="form-label"
                style={{ color: "var(--primary-color3)" }}
              >
                {t("email")}
              </label>
              <input
                id="email"
                type="email"
                value={form.email}
                disabled
                className="form-control"
                style={{ opacity: 0.7 }}
              />
            </div>

            <div className="col-12">
              <label
                htmlFor="registration"
                className="form-label"
                style={{ color: "var(--primary-color3)" }}
              >
                {t("registration_time")}
              </label>
              <input
                type="date"
                id="registration"
                value={form.registration}
                disabled
                className="form-control"
                style={{ opacity: 0.7 }}
              />
            </div>
          </div>
        </div>

        {/* Personal Data */}
        <div
          className="card rounded-3 p-4"
          style={{ background: "var(--primary-color8)" }}
        >
          <h2
            className="h4 fw-semibold mb-4"
            style={{ color: "var(--primary-color3)" }}
          >
            {t("personal_data")}
          </h2>

          <div className="row g-4">
            {/* Username */}
            <div className="col-12">
              <label
                htmlFor="username"
                className="form-label"
                style={{ color: "var(--primary-color3)" }}
              >
                {t("username")}
              </label>
              <input
                type="text"
                id="username"
                value={form.username}
                onChange={handleChange}
                className={`form-control ${errors.username ? "is-invalid" : ""}`}
              />
              {errors.username && (
                <div className="text-danger small mt-1">
                  {errors.username[0]}
                </div>
              )}
            </div>

            {/* WhatsApp */}
            <div className="col-md-6">
              <label
                htmlFor="whatssap"
                className="form-label"
                style={{ color: "var(--primary-color3)" }}
              >
                {t("whatssap")}
              </label>
              <input
                type="text"
                id="whatssap"
                className={`form-control ${errors.whatssap ? "is-invalid" : ""}`}
                placeholder={t("placeholder_whatsapp")}
                value={form.whatssap}
                onChange={handleChange}
              />
              {errors.whatssap && (
                <div className="text-danger small mt-1">
                  {errors.whatssap[0]}
                </div>
              )}
            </div>

            {/* Postal Code */}
            <div className="col-md-6">
              <label
                htmlFor="code_postal"
                className="form-label"
                style={{ color: "var(--primary-color3)" }}
              >
                {t("code_postal")}
              </label>
              <input
                type="text"
                id="code_postal"
                placeholder={t("placeholder_postal_code")}
                className={`form-control ${
                  errors.code_postal ? "is-invalid" : ""
                }`}
                value={form.code_postal}
                onChange={handleChange}
              />
              {errors.code_postal && (
                <div className="text-danger small mt-1">
                  {errors.code_postal[0]}
                </div>
              )}
            </div>

            <div className="col-12 pt-3">
              <Button type="primary" onClick={handleSave}>
                {t("save_changes")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountInformation;
